import api from '../utils/api';

const BASE = '/api/search';

/**
 * Search scenarios or users by keyword.
 * @route GET /api/search
 * @param {string} query - The search term
 * @param {'scenario'|'user'} type - Entity type to search
 * @param {boolean} [isTag=false] - Restrict scenario search to exact tag-name match
 * @returns {Promise<{ results: Object[] }>} Up to 50 matching scenarios or users
 */
export const search = (query, type, isTag = false) =>
    api.get(BASE, { params: { query, type, tag: isTag } }).then((r) => r.data);
